import { render, staticRenderFns } from "./Splitsing.vue?vue&type=template&id=437c8668&"
import script from "./Splitsing.vue?vue&type=script&lang=ts&"
export * from "./Splitsing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports